<template>
    <v-container fluid>
    <!-- Upload Dialog -->
        <A6BackgroundImageUploadDialog :item="currentItem" />

    <!-- Validation Component -->
        <ValidationObserver 
            ref="settings"
            v-slot="{ passes}"
        >
        <!-- Headline -->
            <v-row>
                <v-col 
                    class="headline d-flex justify-start"
                    :alvqa="alvqa + '-title'"
                >
                    {{ $t('lang_ACCOUNT_SETTINGS') }}
                </v-col>
                <v-spacer></v-spacer>
                <v-col class="d-flex justify-end">
                    <BaseButton 
                        class="mb-4"
                        label="lang_GENERAL_BUTTON_SAVE"
                        @click="passes(save)"
                        alvqa="account-settings-button-save"
                    />
                </v-col>
            </v-row>
            <v-expansion-panels multiple>
                <BasePanel 
                    v-for="(settings, index) in getPanels"
                    :key="index"
                    :headline="settings"
                    :alvqa="alvqa + '-' + index"
                >
                    <template v-slot:panelContent>
                        <v-container fluid>
                            <div v-for="(items, index) in companySettings(settings)" :key="index">
                                <v-row v-for="(item, index) in items" :key="index" :id="`settings-${item.id}`">
                                <!--  Settings Name -->
                                    <v-col cols="3">
                                        <div 
                                            v-if="item.topic === '0'" 
                                            :id="`name-${item.id}`"
                                            :alvqa="alvqa + `-${item.id}-topic`"
                                        >
                                            {{ $t(item.name) }}
                                        </div>
                                        <div 
                                            v-else 
                                            :id="`name-${item[0].id}`"
                                            :alvqa="alvqa + `-${item[0].id}-topic`"
                                        >
                                            {{ $t(item[0].name )}}
                                        </div>
                                    </v-col>
                                    <v-col>
                                    <!--  Settings Description -->
                                        <v-row class="pr-3 pt-3">
                                            <div 
                                                v-if="item.topic === '0'" 
                                                :id="`description-${item.id}`"
                                                :alvqa="alvqa + `-${item.id}-description`"
                                            >
                                                {{ $t(item.description) }}
                                            </div>
                                            <div 
                                                v-else 
                                                :id="`description-${item[0].id}`"
                                                :alvqa="alvqa + `-${item[0].id}-description`"
                                            >
                                                {{ $t(item[0].description) }}
                                            </div>
                                        </v-row>

                                        <!-- Topic: 0 = Common -->
                                        <v-row v-if="item.topic === '0'">
                                            <v-col cols="7" class="pb-4">
                                                <!-- If type is 0 = dropdown or textfield -->
                                                <div v-if="item.type === '0'">
                                                    <v-row class="pt-0 mt-0" >
                                                        <v-col cols="10" class="pt-0 mt-0 pb-0">
                                                            <SettingsDropdown 
                                                                v-if="item.option1 === 'lang_UNIT_PT'"
                                                                :item="item"
                                                                :options="getFontSizes"
                                                                :clearable="true"
                                                                :id="'dropdown-'+item.id"
                                                                :alvqa="alvqa + `-${item.id}-dropdown`"
                                                            />
                                                            <SettingsTextfield 
                                                                v-else
                                                                :item="item"
                                                                :alvqa="alvqa + `-${item.id}-textfield`"
                                                            />
                                                        </v-col>
                                                        <v-col 
                                                            v-if="item.option1 !== ''"
                                                            cols="1" 
                                                            class="mt-2 mr-5"
                                                            :alvqa="alvqa + `-${item.id}-metric-unit`"
                                                        >{{ $t(item.option1) }}</v-col>
                                                    </v-row>
                                                </div>
                                                <!-- If type is 1 = dropdown (was formerly radio buttons) -->
                                                <div v-if="item.type === '1'">
                                                    <SettingsDropdown 
                                                        :item="item"
                                                        :options="getOptions(item)"
                                                        :id="'dropdown-'+item.id"
                                                        :alvqa="alvqa + '-' + `${item.id}-dropdown`"
                                                    />
                                                </div>
                                                <!-- If type is 2 = checkbox -->
                                                <div v-if="item.type === '2'">
                                                    <SettingsCheckbox 
                                                        :item="item"
                                                        :label="$t(item.option1)"
                                                        :id="'checkbox-'+item.id"
                                                        :alvqa="alvqa + '-' + `${item.id}-checkbox`"
                                                    />
                                                </div>
                                                <!-- If type is 3 = upload -->
                                                <div v-if="item.type === '3'">
                                                    <BaseButton 
                                                        @click="openA6BackgroundImageUploadDialog(item)"
                                                        label="lang_GENERAL_BUTTON_UPLOAD_FILE"
                                                        :id="'upload-'+item.id"
                                                        :alvqa="alvqa + '-' + `${item.id}-button-upload`"
                                                    />
                                                    <BaseIcon 
                                                        v-if="item.value !== null"
                                                        icon="delete"
                                                        color="iconDelete"
                                                        @click="deleteA6BackgroundImage(item)"
                                                        tooltipText="lang_GENERAL_CAPTION_DELETE_FILE"
                                                        :id="'delete-'+item.id"
                                                        :alvqa="alvqa + '-' + `${item.id}-icon-delete`"
                                                    />
                                                </div>
                                                <!-- If type is 4 = font picker -->
                                                <div v-if="item.type === '4'">
                                                    <v-row class="pt-0 mt-0">
                                                        <v-col class="pt-0 mt-0">
                                                            <font-picker
                                                                :api-key="'AIzaSyCcaOvfhD8FjLAYHnfs8mwALP3lY-go8E4'"
                                                                :active-font="item.value !== null ? item.value : item.default"
                                                                :options="{ limit: 200, name: item.id, variants: ['regular', '700'] }"   
                                                                @change="changeFont($event, item)"
                                                                :alvqa="alvqa + '-' + `${item.id}-dropdown-font-picker`"
                                                            ></font-picker>
                                                        </v-col>
                                                        <v-col 
                                                            cols="2" 
                                                            :class='`apply-font-${item.id}`'
                                                            :alvqa="alvqa + '-' + `${item.id}-dropdown-font-picker-preview`"
                                                        >
                                                            {{ $t(item.option1) }}
                                                        </v-col>
                                                    </v-row>
                                                </div>
                                            </v-col>
                                        </v-row>
                                        <!-- Topic: 1 = Excel sheet + PDF -->
                                        <v-row v-else-if="item[0].topic === '1'">
                                            <v-col>
                                                <v-row>
                                                    <v-col 
                                                        cols="5" 
                                                        :id="'header-name-'+item[0].id"
                                                        :alvqa="alvqa + '-' + item[0].id + '-header-name'"
                                                    >
                                                        {{ $t('lang_ACCOUNT_SETTINGS_CAPTION_NAME') }}
                                                    </v-col>
                                                    <v-col 
                                                        v-if="hasExcelOptions(item)"
                                                        cols="1" 
                                                        :id="'header-excel-'+item[0].id"
                                                        :alvqa="alvqa + '-' + item[0].id + '-header-excel'"
                                                    >
                                                        {{ $t('lang_GENERAL_CAPTION_EXCEL') }}
                                                    </v-col>
                                                    <v-col 
                                                        :id="'header-pdf'+item[0].id"
                                                        :alvqa="alvqa + '-' + item[0].id + '-header-pdf'"
                                                    >
                                                        {{ $t('lang_GENERAL_CAPTION_PDF') }}
                                                    </v-col>
                                                </v-row>
                                                <v-row v-for="(row, name, index) in topicOneValues(item)" :key="index">
                                                    <v-col 
                                                        cols="5" 
                                                        :id="'row-name-'+(row.excelOption ? row.excelOption.id : '')+'-'+(row.pdfOption ? row.pdfOption.id : '')"
                                                        :alvqa="alvqa + '-' + item[0].id + '-option-' + index"
                                                    >
                                                        {{ $t(name) }}
                                                    </v-col>
                                                    <v-col 
                                                        v-if="row.excelOption"
                                                        cols="1"
                                                        :alvqa="alvqa + '-' + item[0].id + '-excel-checkbox-' + index"
                                                    >
                                                        <SettingsCheckbox 
                                                            :item="row.excelOption"
                                                            :id="'checkbox-excel-'+row.excelOption.id"
                                                            :alvqa="alvqa + '-' + item[0].id + '-excel-checkbox-' + index"
                                                        />
                                                    </v-col>
                                                    <v-col :alvqa="alvqa + '-' + item[0].id + '-pdf-checkbox-' + index">
                                                        <SettingsCheckbox 
                                                            v-if="row.pdfOption"
                                                            :item="row.pdfOption"
                                                            :id="'checkbox-pdf-'+(row.pdfOption ? row.pdfOption.id : '')"
                                                            :alvqa="alvqa + '-' + item[0].id + '-checkbox-' + index"
                                                        />
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <!-- Topic: 2 = Excel column -->
                                        <v-row v-else-if="item[0].topic === '2'">
                                            <v-col>
                                                <v-row>
                                                    <v-col 
                                                        cols="5" 
                                                        :id="'header-column-'+item[0].id"
                                                        :alvqa="alvqa + '-' + item[0].id + '-header-column'"
                                                    >
                                                        {{  $t('lang_ACCOUNT_SETTINGS_CAPTION_COLUMN') }}
                                                    </v-col>
                                                    <v-col 
                                                        :id="'header-show-'+item[0].id"
                                                        :alvqa="alvqa + '-' + item[0].id + '-header-show'"
                                                    >
                                                        {{ $t('lang_ACCOUNT_SETTINGS_CAPTION_SHOW') }}
                                                    </v-col>
                                                </v-row>
                                                <v-row v-for="(row, index) in item" :key="index">
                                                    <v-col 
                                                        cols="5" 
                                                        :id="'row-name-'+row.id"
                                                        :alvqa="alvqa + '-' + row.id + '-option-' + index"
                                                    >
                                                        {{ 
                                                            $t(row.option1).replace(/{CURRENCY}/gi, matched => { 
                                                                return { '{CURRENCY}': $store.getters.getSelectedCurrency }[matched]
                                                            }) 
                                                        }}
                                                    </v-col>
                                                    <v-col :alvqa="alvqa + '-' + row.id + '-checkbox-' + index">
                                                        <SettingsCheckbox 
                                                            :item="row"
                                                            :id="'checkbox-show-'+row.id"
                                                            :alvqa="alvqa + '-' + row.id + '-checkbox-' + index"
                                                        />
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-container>
                    </template>
                </BasePanel>
            <!-- Publishing > Usage: settings with an API of their own, in the same panels -->
                <template v-if="isPublishing">
                    <UsageMatchingSettingsPanel />
                    <UsageEpisodePatternsSettingsPanel />
                </template>
            </v-expansion-panels>
        </ValidationObserver>
    </v-container>
</template>

<script>
import BaseIcon from '@/components/_buttons/BaseIcon'
import BasePanel from '@/components/_base/BasePanel'
import BaseButton from '@/components/_buttons/BaseButton'
import FontPicker from 'font-picker-vue'
import SettingsCheckbox from './SettingsCheckbox'
import SettingsDropdown from './SettingsDropdown'
import SettingsTextfield from './SettingsTextfield'
import A6BackgroundImageUploadDialog from './_dialogs/A6BackgroundImageUploadDialog'
import UsageMatchingSettingsPanel from './_panels/UsageMatchingSettingsPanel'
import UsageEpisodePatternsSettingsPanel from './_panels/UsageEpisodePatternsSettingsPanel'

export default {
    name: "Settings",
    components: {
        BaseIcon,
        BasePanel,
        BaseButton,
        FontPicker,
        SettingsCheckbox,
        SettingsDropdown,
        SettingsTextfield,
        A6BackgroundImageUploadDialog,
        UsageMatchingSettingsPanel,
        UsageEpisodePatternsSettingsPanel
    },
    data() {
        return {
            currentItem: {},
            alvqa: 'account-settings'
        }
    },
    computed: {
        publishingSettings: { 
            get() { return this.$store.getters.getPublishingSettings },
            set(values) { this.$store.commit('setPublishingSettings', values) }
        },

        labelSettings: { 
            get() { return this.$store.getters.getLabelSettings },
            set(values) { this.$store.commit('setLabelSettings', values) }
        },

        selectedCompany: {
          get() { return this.$store.getters.getSelectedOverAllCompany },
          set(selected) { this.$store.commit('setSelectedOverAllCompany', selected) }
        },

        showUploadDialog: {
            get() { return this.$store.getters.getShowUploadDialog },
            set(show) { this.$store.commit('setShowUploadDialog', show) }
        },

        publishingPanels() { return Object.keys(this.publishingSettings) },
        labelPanels() { return Object.keys(this.labelSettings) },

        getFontSizes() { 
            return ['7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '18', '20', '24', '30', '36', '48', '64'] 
        },

        isPublishing() { return this.selectedCompany.context === 1 },

        getPanels() {
            if(this.selectedCompany.context === 1) return this.publishingPanels
            else return this.labelPanels
        },
    },
    methods: {
        companySettings(settings) {
            if(this.selectedCompany.context === 1) return this.publishingSettings[settings]
            else return this.labelSettings[settings]
        },

        getOptions(item) {
            let options = []
            if(item.option1 !== '') options.push({text: this.$t(item.option1), value: '0'})
            if(item.option2 !== '') options.push({text: this.$t(item.option2), value: '1'})
            if(item.option3 !== '') options.push({text: this.$t(item.option3), value: '2'})
            return options
        },

        topicOneValues(item) {
            let values = {}
            let type = ""
            
            item.forEach(element => {
                type = element.topic_parameter === '0' ? 'excelOption' : 'pdfOption' 
                if(values[element.option1] === undefined) {
                    values[element.option1] = {} 
                } 
                values[element.option1][type] = element
            })

            return values
        },

        hasExcelOptions(item) {
            return item.some(element => element.topic_parameter === '0')
        },

        changeFont(nextFont, item) {
            item.value = nextFont.family
        },

        async deleteA6BackgroundImage(item) {
            let response = await this.$store.dispatch('deleteA6BackgroundImage', { companyId: item.company, companyContext: this.selectedCompany.context, settingId: item.id })
            if(response.error === -1) {
                this.$store.commit('setSnackbar', {
                    type: 'success',
                    msg:  this.$t('lang_ACCOUNT_SETTINGS_SNACKBAR_IMAGE_DELETED')
                })

                // Update the settings data, do fetch call again
                if(this.selectedCompany.context === 1) this.$store.dispatch('fetchPublishingSettings')
                else this.$store.dispatch('fetchLabelSettings')
            } else {
                this.$store.commit('setSnackbar', {
                    type: 'error',
                    msg:  this.$t('lang_ACCOUNT_SETTINGS_SNACKBAR_IMAGE_NOT_DELETED')
                })
            }
        },

        openA6BackgroundImageUploadDialog(item) {
            this.currentItem = item
            this.showUploadDialog = true
        },

        save() {
            if(this.selectedCompany.context === 1) {
                this.$store.dispatch('saveSettings', this.publishingSettings)
                this.$store.dispatch('saveUsageTolerance')
            }
            else this.$store.dispatch('saveSettings', this.labelSettings)
        },
    },
    created() {
        if(this.selectedCompany.context === 1) this.$store.dispatch('fetchUsageSettings')
        if(this.selectedCompany.context === 1) this.$store.dispatch('fetchPublishingSettings')
        else this.$store.dispatch('fetchLabelSettings')
    }
}
</script>